import { BBadge } from './badge';
import { pluginFactory } from '../../utils/plugins';
var BadgePlugin = /*#__PURE__*/pluginFactory({
  components: {
    BBadge: BBadge
  }
});
export { BadgePlugin, BBadge };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/badge/index.js
// module id = 288
// module chunks = 44